import React from "react";
import { cn } from "../../lib/utils";

// Main Layout Container
interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const Layout: React.FC<LayoutProps> = ({ children, className }) => {
  return (
    <div
      className={cn(
        "min-h-screen bg-background text-foreground flex",
        className
      )}
    >
      {children}
    </div>
  );
};

// Layout Content Area (main content)
interface LayoutContentProps {
  children: React.ReactNode;
  className?: string;
}

export const LayoutContent: React.FC<LayoutContentProps> = ({ 
  children, 
  className 
}) => {
  return (
    <main
      className={cn(
        "flex-1 flex flex-col overflow-auto max-h-screen",
        className
      )}
    >
      {children}
    </main>
  );
};

// Layout Body (scrollable content area)
interface LayoutBodyProps {
  children: React.ReactNode;
  className?: string;
}

export const LayoutBody: React.FC<LayoutBodyProps> = ({ 
  children, 
  className 
}) => {
  return (
    <div
      className={cn(
        "flex-1 overflow-auto",
        "px-6 py-6", // Default padding
        className
      )}
    >
      {children}
    </div>
  );
};

// Layout Header
interface LayoutHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const LayoutHeader: React.FC<LayoutHeaderProps> = ({ 
  children, 
  className 
}) => {
  return (
    <header
      className={cn(
        "flex items-center justify-between",
        "h-16 px-6 border-b border-border bg-card/50",
        "sticky top-0 z-10 backdrop-blur-sm",
        className
      )}
    >
      {children}
    </header>
  );
};